// extracted by mini-css-extract-plugin
export default {"wrapper":"SjxpPTIffcWwA885VSlV","text":"TPqX9A9VBM4oF6aDXt4k"};